module.exports = __webpack_public_path__ + "static/media/Elefant.644274fb.mp3";